/**
 * TODO: NEXUS V3.29.0
 * This component was partially implemented.
 * Workspaces View Links have been hidden for Agency Reports and My Reports.
 */
import React, { useContext, useEffect, useMemo } from 'react';
import SFNavPanel, {
  SFNavPanelProps
} from '../../../Components/SFNavPanel/SFNavPanel';
import {
  isPlanConnect,
  checkPermissions,
  isRoleOfficer,
  isRoleWatcher,
  User,
  SubscriptionsSummary,
  AppOptionsContext,
  AGENCY_PROJECTS_READ
} from 'ui-smartforce-settings';
import { SFNavLink } from '../../../Components/SFNavPanel/SFNavLink';
import {
  AGENCY_REPORTS_READ,
  AGENCY_REPORTS_CREATE,
  USER_REPORTS_READ,
  AGENCY_REPORTS_COLLABORATION_READ
} from '../../../Constants/RolesAndPermissions';
import { useHistory, useLocation } from 'react-router-dom';

export interface MainNavMenuProps extends Omit<
  SFNavPanelProps,
  'links' | 'bottomLinks'
> {
  user: User;
  subscriptionsSummary: SubscriptionsSummary;
  isPhone: boolean;
  onToursClick: () => void;
  onFeedbackClick: () => void;
  onTitleChange: (title: string) => void;
}

export const MainNavMenu = ({
  user,
  subscriptionsSummary,
  isPhone,
  onToursClick,
  onFeedbackClick,
  onTitleChange,
  ...props
}: MainNavMenuProps): React.ReactElement<MainNavMenuProps> => {
  const location = useLocation();
  const history = useHistory();
  const { workspaces } = useContext(AppOptionsContext);

  const links: SFNavLink[] = useMemo(() => {
    let myLinks: SFNavLink[] = [];

    if (user) {
      if (
        subscriptionsSummary.appPlan.cc &&
        subscriptionsSummary.hasProjectsIntegration &&
        checkPermissions(AGENCY_PROJECTS_READ, user.role?.permissions)
      ) {
        myLinks = [
          ...myLinks,
          {
            pathname: '/app/command',
            label: 'Command',
            icon: 'Bookmark-11',
            onClick: () => history.push('/app/command'),
            children: [
              {
                pathname: '/app/command/projects',
                label: 'Projects',
                onClick: () => history.push('/app/command/projects')
              }
              //...childrenLinks
            ].sort((a, b) => a.label.localeCompare(b.label))
          }
        ];
      }

      if (
        subscriptionsSummary.appPlan.cc &&
        !isPlanConnect(subscriptionsSummary.appPlan.cc) &&
        checkPermissions(AGENCY_REPORTS_READ, user.role?.permissions)
      ) {
        if (!subscriptionsSummary.appPlan.nexus) {
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/agency-reports/contacts',
              label: 'Agency Reports',
              icon: 'Users',
              onClick: () => history.push('/app/agency-reports/contacts')
            }
          ];
        } else {
          // TODO: It was commented out in the original code for NEXUS, but it seems like it was intended to be used.
          // const childrenLinks = workspaces.map((workspace) => ({
          //   pathname: `/app/agency-reports/workspaces/${workspace.id}`,
          //   label: workspace.name,
          //   onClick: () =>
          //     history.push(`/app/agency-reports/workspaces/${workspace.id}`)
          // }));
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/agency-reports',
              label: 'Agency Reports',
              icon: 'Users',
              onClick: () => history.push('/app/agency-reports'),
              children: [
                {
                  pathname: '/app/agency-reports/contacts',
                  label: 'Contacts',
                  onClick: () => history.push('/app/agency-reports/contacts')
                }
                //...childrenLinks
              ].sort((a, b) => a.label.localeCompare(b.label))
            }
          ];
        }
      } else {
        // TODO: It was commented out in the original code for NEXUS, but it seems like it was intended to be used.
        // if (
        //   subscriptionsSummary.appPlan.nexus &&
        //   checkPermissions(AGENCY_REPORTS_READ, user.role?.permissions)
        // ) {
        //   const childrenLinks = workspaces.map((workspace) => ({
        //     pathname: `/app/agency-reports/workspaces/${workspace.id}`,
        //     label: workspace.name,
        //     onClick: () =>
        //       history.push(`/app/agency-reports/workspaces/${workspace.id}`)
        //   }));
        //   myLinks = [
        //     ...myLinks,
        //     {
        //       pathname: '/app/agency-reports',
        //       label: 'Agency Reports',
        //       icon: 'Users',
        //       onClick: () => history.push('/app/agency-reports'),
        //       children: [...childrenLinks].sort((a, b) => a.label.localeCompare(b.label))
        //     }
        //   ];
        // }
      }

      if (
        subscriptionsSummary.appPlan.cc &&
        !isPlanConnect(subscriptionsSummary.appPlan.cc) &&
        checkPermissions(AGENCY_REPORTS_CREATE, user.role?.permissions)
      ) {
        myLinks = [
          ...myLinks,
          {
            pathname: '/app/report',
            label: 'Create Report',
            icon: 'Add-File',
            offline: true,
            onClick: () => history.push('/app/report')
          }
        ];
      }

      if (
        subscriptionsSummary.appPlan.cc &&
        !isPlanConnect(subscriptionsSummary.appPlan.cc) &&
        checkPermissions(USER_REPORTS_READ, user.role?.permissions)
      ) {
        if (!subscriptionsSummary.appPlan.nexus) {
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/my-reports/contacts',
              label: 'My Reports',
              icon: 'Files',
              onClick: () => history.push('/app/my-reports/contacts')
            }
          ];
        } else {
          // TODO: It was commented out in the original code for NEXUS, but it seems like it was intended to be used.
          // const childrenLinks = workspaces.map((workspace) => ({
          //   pathname: `/app/my-reports/workspaces/${workspace.id}`,
          //   label: workspace.name,
          //   onClick: () =>
          //     history.push(`/app/my-reports/workspaces/${workspace.id}`)
          // }));
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/my-reports',
              label: 'My Reports',
              icon: 'Files',
              onClick: () => history.push('/app/my-reports'),
              children: [
                {
                  pathname: '/app/my-reports/contacts',
                  label: 'Contacts',
                  onClick: () => history.push('/app/my-reports/contacts')
                }
                //...childrenLinks
              ].sort((a, b) => a.label.localeCompare(b.label))
            }
          ];
        }
      } else {
        // TODO: It was commented out in the original code for NEXUS, but it seems like it was intended to be used.
        // if (
        //   subscriptionsSummary.appPlan.nexus &&
        //   checkPermissions(USER_REPORTS_READ, user.role?.permissions)
        // ) {
        //   const childrenLinks = workspaces.map((workspace) => ({
        //     pathname: `/app/my-reports/workspaces/${workspace.id}`,
        //     label: workspace.name,
        //     onClick: () =>
        //       history.push(`/app/my-reports/workspaces/${workspace.id}`)
        //   }));
        //   myLinks = [
        //     ...myLinks,
        //     {
        //       pathname: '/app/my-reports',
        //       label: 'My Reports',
        //       icon: 'Files',
        //       onClick: () => history.push('/app/my-reports'),
        //       children: [...childrenLinks].sort((a, b) => a.label.localeCompare(b.label))
        //     }
        //   ];
        // }
      }

      if (
        subscriptionsSummary.appPlan.cc &&
        !isPlanConnect(subscriptionsSummary.appPlan.cc) &&
        isRoleOfficer(user.role.id) &&
        checkPermissions(
          AGENCY_REPORTS_COLLABORATION_READ,
          user?.role?.permissions
        )
      ) {
        myLinks = [
          ...myLinks,
          {
            pathname: '/app/collaborated-reports',
            label: 'Collaborated Reports',
            icon: 'Share-File-2',
            onClick: () => history.push('/app/collaborated-reports')
          }
        ];
      }

      myLinks = [
        ...myLinks,
        {
          pathname: '/app/business-card',
          label: 'Business Card',
          icon: 'Name-Tag',
          offline: true,
          onClick: () => history.push('/app/business-card')
        }
      ];

      if (
        subscriptionsSummary.appPlan.cc &&
        !isPlanConnect(subscriptionsSummary.appPlan.cc)
      ) {
        if (!subscriptionsSummary.appPlan.nexus) {
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/analytics/contacts',
              label: 'Analytics',
              icon: 'Block-Chart-1',
              onClick: () => history.push('/app/analytics/contacts')
            }
          ];
        } else {
          const childrenLinks = workspaces.map((workspace) => ({
            pathname: `/app/analytics/workspaces/${workspace.id}`,
            label: workspace.name,
            onClick: () =>
              history.push(`/app/analytics/workspaces/${workspace.id}`)
          }));
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/analytics',
              label: 'Analytics',
              icon: 'Block-Chart-1',
              onClick: () => history.push('/app/analytics'),
              children: [
                {
                  pathname: '/app/analytics/contacts',
                  label: 'Contacts',
                  onClick: () => history.push('/app/analytics/contacts')
                },
                ...childrenLinks
              ].sort((a, b) => a.label.localeCompare(b.label))
            }
          ];
        }
      } else {
        if (subscriptionsSummary.appPlan.nexus) {
          const childrenLinks = workspaces.map((workspace) => ({
            pathname: `/app/analytics/workspaces/${workspace.id}`,
            label: workspace.name,
            onClick: () =>
              history.push(`/app/analytics/workspaces/${workspace.id}`)
          }));
          myLinks = [
            ...myLinks,
            {
              pathname: '/app/analytics',
              label: 'Analytics',
              icon: 'Block-Chart-1',
              onClick: () => history.push('/app/analytics'),
              children: [...childrenLinks].sort((a, b) =>
                a.label.localeCompare(b.label)
              )
            }
          ];
        }
      }
    }

    myLinks = [
      ...myLinks,
      {
        pathname: '/app/amend',
        label: 'Amend Report',
        icon: 'Pencil',
        temporal: true
      }
    ];

    return myLinks;
  }, [history, subscriptionsSummary, user, workspaces]);

  const bottomLinks: SFNavLink[] = useMemo(() => {
    let links: SFNavLink[] = [
      {
        pathname: '/app/settings',
        label: 'Settings',
        icon: 'Preferences-1',
        onClick: () => history.push('/app/settings')
      }
    ];

    if (
      subscriptionsSummary.appPlan.cc &&
      !isPhone &&
      !isRoleWatcher(user?.role.id)
    ) {
      links = [
        ...links,
        {
          label: 'Feature Tours',
          icon: 'Rectangle-Star',
          onClick: onToursClick
        }
      ];
    }

    return [
      ...links,
      {
        label: 'Feedback',
        icon: 'Speach-Bubble',
        onClick: onFeedbackClick
      },
      {
        to: `${process.env.REACT_APP_CC_SUPPORT_URL}`,
        label: 'Support',
        icon: 'Question-Mark',
        onClick: () =>
          window.open(process.env.REACT_APP_CC_SUPPORT_URL as string, '_blank')
      }
    ];
  }, [
    history,
    isPhone,
    onFeedbackClick,
    onToursClick,
    subscriptionsSummary.appPlan.cc,
    user?.role.id
  ]);

  useEffect(() => {
    const activeLink: SFNavLink | undefined = links.find(
      (link: SFNavLink) =>
        link.pathname && location.pathname.includes(link.pathname)
    );

    onTitleChange(activeLink ? activeLink.label : 'Settings');
  }, [links, location.pathname, onTitleChange]);

  return (
    <SFNavPanel
      className={props.className}
      links={links}
      bottomLinks={bottomLinks}
      isBigScreen={props.isBigScreen}
      isOpen={props.isOpen}
      onClose={props.onClose}
      reminderProps={props.reminderProps}
    />
  );
};
